import { Container } from './Container';
import { Content } from './Content';
import { Meta } from './Meta';
import { MessageText } from './Message';

export default {
  Container,
  Content,
  Meta,
  MessageText,
};
